import { createContentPropTypes } from '../../helpers/content';

const content = {
	title: 'Payment authorisation',
	subText: 'Please select who will be responsible for authorising this payment.',
	dismissButtonLabel: 'Cancel',
	confirmButtonLabel: 'Continue',
	singleListHeader: 'Select one person from this list',
	multiListHeader: 'Select two people from this list',
	noUsers:
		'Sorry, there aren’t enough users with the correct permissions to authorise this payment. Please contact your corporate administrator or get in touch with us for more information.',
	noUsersTitle: 'Not enough users',
	selectedTooManyAuthorisers:
		'You have already selected two authorisers for this payment. Please deselect an authoriser before attempting to add more.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
